import DataDisplayRowI from "../DataDisplayRowI";
import getMemberRow from "../DataDisplayRow/MemberRow";
import DataDisplayTable from "../DataDisplayTable";

class MemberTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getMemberRow()
    }
}

let memberTable: MemberTable | null = null;

export default function getMemberTable(): MemberTable {
    if (memberTable === null)
        memberTable = new MemberTable()
    return memberTable
}